export enum LangCode {
    en = 'en',
    vi = 'vi'
}

export enum dateTimeLocales {
    en = "en-US",
    vi = "vi-VN",
}